import { render, staticRenderFns } from "./Ses.vue?vue&type=template&id=7d54df06&scoped=true&"
import script from "./Ses.vue?vue&type=script&lang=js&"
export * from "./Ses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54df06",
  null
  
)

export default component.exports